<div>
    <h2 mat-dialog-title>
        {{data.boleta.cliente.numero_xp}} -  {{data.boleta.cliente.nome}}
    </h2>
    <h3>
        Venda de {{data.boleta.qtd | number : '1.0-0'}} - {{data.boleta.ativo.sigla}} a R$ {{data.boleta.valor | number : '1.2-2'}}
    </h3>
</div>


<div mat-dialog-content> 
    <div 
        class="tabela_principal mat-elevation-z8"
        ngClass="example-container-full" 
    >
        <table mat-table [dataSource]="rows">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let row; let i = index">
                    <mat-checkbox 
                        (click)="$event.stopPropagation()"
                        (change)="$event ? addTogleSelection(i) : null"
                        [checked]="selection.isSelected(row.id)"
                        [disabled]="row.tipo == 'V' ? true : false"
                        [aria-label]="checkboxLabel(row.id)"
                    >
                    </mat-checkbox>
                </td>                
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>Data</th>
                <td mat-cell *matCellDef="let element"> {{element.created_at | date:'dd/MM/yyyy'}} </td>                
            </ng-container>

            <ng-container matColumnDef="ativo">
                <th mat-header-cell *matHeaderCellDef>Ativo</th>
                <td mat-cell *matCellDef="let element"> {{element.sigla}} </td>                
            </ng-container>

            <ng-container matColumnDef="qtd_executado">
                <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                <td mat-cell *matCellDef="let element"> {{element.qtd_executado}} </td>                
            </ng-container>

            <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef>Operação</th>
                <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>                
            </ng-container>

            <ng-container matColumnDef="vlr_financeiro">
                <th mat-header-cell *matHeaderCellDef>Valor Financeiro</th>
                <td mat-cell *matCellDef="let element"> R$ {{element.vlr_financeiro | number : '1.2-2'}} </td>                
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr 
                mat-row 
                *matRowDef="let row; columns: columnsToDisplay; let i = index"
                (click)="selection.toggle(row.id)"
            >
            </tr>            
        </table>
    </div> 
    <div>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>Estratégia</mat-label>
                    <mat-select 
                        placeholder="Estrategias de Renda Variável"
                        [formControl]="estrategia_id"
                        name="estrategia_id"                         
                        required
                    >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option 
                            *ngFor="let estrategia of listEstrategia" 
                            [value]="estrategia.id"
                        >
                            {{estrategia.nome}}
                        </mat-option>
                    </mat-select> 
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                    <mat-error *ngIf="estrategia_id.invalid">{{getErrorEstrategiaMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field  appearance="outline" fxFlex="100">
                    <input 
                        matInput 
                        placeholder="Valor R$" 
                        [formControl]="total_financeiro"
                        name="valor"
                        maxlength="100"
                        currencyMask                    
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    >      
                    <mat-error *ngIf="total_financeiro.invalid">{{getErrorValorMessage()}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
   
</div>
<div mat-dialog-actions right>
    <button 
        mat-button 
        color="warn"
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    <button 
        mat-button         
        (click)="gerar()"
        tabindex="-1"
        [disabled]="isInvalidForm()"
    >
        Boletar
    </button>
</div>